module.exports = __webpack_public_path__ + "img/calendar.3e69e508.svg";